/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectRequestPartialPatchV1Patch } from '../../models/update-project-request-partial-patch-v-1-patch';
import { UpdateProjectResponse } from '../../models/update-project-response';

export interface ProjectsControllerPatchProject$Params {

/**
 * Project id.
 */
  id: string;

/**
 * Optional query parameter denoting a method name which affected by this PATCH call, so that
 *         API can skip potential shared dependency recalculation for this method
 */
  affectedCalculationMethod?: Array<'LIVING_SPACE' | 'BUILDING_HULL' | 'ENERGY_CERTIFICATE' | 'CONSUMPTION' | 'CUSTOM_VALUE' | 'INSTALLATION' | 'ROOM_BY_ROOM'>;

/**
 * Language code of the application performing API request.
 */
  'x-ca-application-lang-code'?: 'cs' | 'de' | 'en' | 'es' | 'fr' | 'nl' | 'pl' | 'sk';

/**
 * A header used for security reasons. Header is automatically sent by browsers. When using the code-to-API solution (calling this API directly by script code or other API) please contact <strong>Customer Apps</strong> team for more details.
 */
  referer?: string;

/**
 * Authentication token from Viessmann IAM OAuth2. Required for VIESSMANN_IAM authentication.
 */
  authorization?: string;

/**
 * Application ID identifying the client application. Required for VIESSMANN_IAM authentication.
 */
  'x-application-id'?: 'HEAT_PUMP_PLANNER' | 'PHOTOVOLTAIC_PLANNER' | 'VENTILATION_PLANNER' | 'VIGUIDE_PLANNING' | 'HOME_PLANNER' | 'BOILER_PLANNER' | 'SALESFORCE' | 'CONFIGURATION_PORTAL' | 'AIR_TO_AIR';

/**
 * Country code of the client application instance. Required for VIESSMANN_IAM authentication.
 */
  'x-application-country-code'?: 'AT' | 'BE' | 'CH' | 'CZ' | 'DE' | 'ES' | 'FR' | 'NL' | 'PL' | 'SK' | 'LU';
  
    /**
     * Patching request - contains only fields to be modified.
     */
    body?: UpdateProjectRequestPartialPatchV1Patch
}

export function projectsControllerPatchProject(http: HttpClient, rootUrl: string, params: ProjectsControllerPatchProject$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectResponse>> {
  const rb = new RequestBuilder(rootUrl, projectsControllerPatchProject.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('affectedCalculationMethod', params.affectedCalculationMethod, {});
    rb.header('x-ca-application-lang-code', params['x-ca-application-lang-code'], {});
    rb.header('referer', params.referer, {});
    rb.header('authorization', params.authorization, {});
    rb.header('x-application-id', params['x-application-id'], {});
    rb.header('x-application-country-code', params['x-application-country-code'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectResponse>;
    })
  );
}

projectsControllerPatchProject.PATH = '/planning-projects/v1-preview/projects/{id}';
